<template>
  <KTPortlet :title="title" style="font-size: 24px">
    <template v-slot:body>
      <div class="d-flex justify-content-between">
        <b-button id="go-back" type="button" @click="back" variant="secondary"
          >Go Back</b-button
        >
        <b-button
          id="confirm"
          type="button"
          @click.once="confirm"
          variant="primary"
          >Confirm</b-button
        >
      </div>

      <div class="kt-wizard-v2">
        <div class="kt-wizard-v2__wrapper" style="background-color: white">
          <div class="kt-form review-information" style="border: 0px">
            <div class="kt-wizard-v2__content" style="background-color: white">
              <div class="kt-form__section kt-form__section--first">
                <div class="kt-wizard-v2__review">
                  <div id="order-information" class="kt-wizard-v2__review-item">
                    <div class="kt-wizard-v2__review-title">
                      <h4>Order Information</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <label for="first">First Name: </label>
                      <p name="first">{{ form.orderInformation.firstName }}</p>

                      <label for="last">Last Name: </label>
                      <p name="last">{{ form.orderInformation.lastName }}</p>

                      <label for="em">Email: </label>
                      <p name="em">{{ form.orderInformation.email }}</p>

                      <label for="ord">Order Number: </label>
                      <p name="ord">{{ form.orderInformation.orderNumber }}</p>

                      <label for="curr">Currency: </label>
                      <p name="curr">{{ form.orderDetails.currency }}</p>

                      <label for="sub">Subtotal: </label>
                      <p name="sub">${{ subTotal }}</p>

                      <!-- Promocode Details -->
                      <template v-if="promoCodeDetails.success">
                        <!-- Code name -->
                        <label for="promocodeName">Promocode: </label>
                        <p name="promocodeName">
                          {{ promoCodeDetails.code }}
                        </p>

                        <!-- Code description -->
                        <template v-if="promoCodeDetails.description">
                          <label for="PromocodeDescription"
                            >Promocode Description:
                          </label>
                          <p name="PromocodeDescription">
                            {{ promoCodeDetails.description }}
                          </p>
                        </template>

                        <!-- Discount Amount -->
                        <template v-if="promoCodeDetails.discount">
                          <label for="discountAmount">Discount Amount: </label>
                          <p name="discountAmount">
                            {{ formattedDiscountAmount }}
                          </p>
                        </template>
                      </template>

                      <template v-for="(discount, index) in discounts">
                        <div :key="index">
                          <label for="disc">{{ discount.Name }}: -</label>
                          <p name="disc">${{ discount.Amount }}</p>
                        </div>
                      </template>

                      <label for="tot">Total: </label>
                      <p name="tot">${{ total }}</p>
                    </div>
                  </div>
                  <div
                    v-if="customFields && customFields.length"
                    id="additional-information"
                    class="kt-wizard-v2__review-item"
                  >
                    <div class="kt-wizard-v2__review-title">
                      <h4>Additional Information</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <div
                        v-for="(property, index) in customFields"
                        :key="index"
                      >
                        {{ property.label }}:
                        <p>{{ form.customFieldsModel[property.fieldName] }}</p>
                      </div>
                    </div>
                  </div>
                  <div
                    id="billing-information"
                    class="kt-wizard-v2__review-item"
                  >
                    <div class="kt-wizard-v2__review-title">
                      <h4>Billing Info</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <label for="ad1">Address 1: </label>
                      <p name="ad1">{{ form.billingInfo.Address1 }}</p>

                      <label for="ad2">Address 2: </label>
                      <p name="ad2">{{ form.billingInfo.Address2 }}</p>

                      <label for="city">City: </label>
                      <p name="city">{{ form.billingInfo.City }}</p>

                      <label for="country">Country: </label>
                      <p name="country">{{ form.billingInfo.Country }}</p>
                    </div>
                  </div>
                  <div
                    id="card-information"
                    class="kt-wizard-v2__review-item"
                    style="border-style: none"
                  >
                    <div class="kt-wizard-v2__review-title">
                      <h4>Credit Card Info</h4>
                    </div>
                    <div class="kt-wizard-v2__review-content">
                      <label for="cardnum">Card Number: </label>
                      <p name="cardnum">xxxx xxxx xxxx {{ cardNumber }}</p>

                      <label for="cardname">Card Name: </label>
                      <p name="cardname">
                        {{ form.creditCardInfo.cardHolderName }}
                      </p>

                      <label for="cardtype">Card Type: </label>
                      <p name="cardtype">
                        {{ form.creditCardInfo.cardType.text }}
                      </p>

                      <label for="exp">Card Expiry: </label>
                      <p name="exp">{{ form.creditCardInfo.expiryDate }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:foot>
      <div class="d-flex justify-content-between">
        <b-button
          id="go-back-btm"
          type="button"
          @click="back"
          variant="secondary"
          >Go Back</b-button
        >
        <b-button
          id="confirm-btm"
          type="button"
          @click="confirm"
          variant="primary"
          >Confirm</b-button
        >
      </div>
    </template>
  </KTPortlet>
</template>

<script>
import KTPortlet from "@/views/partials/content/Portlet";
import { currencyFormat } from "@/services/Formatting.js";

export default {
  components: {
    KTPortlet
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    customFields: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      required: false,
      default: "Review your Details and Submit"
    },
    promoCodeDetails: {
      type: Object,
      required: true
    }
  },
  computed: {
    cardNumber() {
      let lastSpace = this.form.creditCardInfo.cnumber.lastIndexOf(" ");

      return this.form.creditCardInfo.cnumber.substring(lastSpace);
    },
    subTotal() {
      return currencyFormat(this.form.orderDetails.amount);
    },
    discountAmount() {
      const value = this.promoCodeDetails;
      if (!value.success) return 0;
      if (!value.discount) return 0;
      if (value.discount.type == "Percentage") {
        return this.form.orderDetails.amount * (value.discount.amount / 100);
      }
      return value.discount.amount;
    },
    formattedDiscountAmount() {
      if (!this.discountAmount) return null;
      return `- $${currencyFormat(this.discountAmount)}`;
    },
    total() {
      return currencyFormat(this.form.orderDetails.total - this.discountAmount);
    },
    discounts() {
      return this.form.orderDetails.discounts.map(d => {
        return { ...d, Amount: currencyFormat(d.Amount) };
      });
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    back() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Open Sans", sans-serif;
}
label {
  /* Other styling... */

  clear: both;
  float: left;
  font-weight: 700;
  font-size: 14px;
}
.kt-wizard-v2__review-content {
  display: grid !important;
  grid-template-columns: 1fr 3fr !important;
}
p {
  font-size: 14px;
}

div.container {
  margin: 5% 10% 5% 0% !important;
}

.review-information {
  border-style: solid;
  border-width: 1px 0px 1px 0px;
  padding: 3% 1% 3% 1%;
  min-width: 100%;
}
</style>
